import { getLogo, website } from '@/utils/helpers';
import React from 'react';

export const Logo = () => {
  return (<img src={getLogo()} height={website.logo.height} width={website.logo.width} alt={website.logo.alt} />)
}
